<script setup lang="ts">
import Banner from './components/Banner.vue';
import Column from './components/Column.vue';
import Content from './components/content/index.vue'
import News from './components/News.vue'
import Footer from './components/Footer.vue';
import Activity from './components/activity/index.vue'
import Customize from './components/Customize.vue';

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <section class="min-w-1200 overflow-x-hidden bg-#fff">
    <div class="container relative">
      <Banner class="relative z-1" />
      <Column class="relative z-1" v-if="props.options.Column == 1" />
      <img src="@/home/assets/home/4/banner.png" class="pointer-events-none absolute right--554 top-0 z-0 select-none">
    </div>

    <div class="mt-100 bg-#f9fafb">
      <div class="container">
        <Activity :is-operation="props.options.OperationCard == 1" />
        <Content :is-tag="props.options.HotTag == 1" />
      </div>
    </div>

    <div class="container mt-80">
      <News />
      <Customize />
    </div>

    <div class="mt-80 border-t-1 border-[#000,10%] border-solid">
      <Footer />
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
